/* GALOBART — navigation enhancements
   Hover-intent opening for the desktop mega menu, Escape to close, click-outside
   dismissal and edge-flipping for the compact dropdowns. Progressive enhancement
   only: without JS the <details> elements still open on click. */
(function () {
  "use strict";

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 240;
  var DESKTOP = "(min-width: 990px)";
  var EDGE_GAP = 12;

  /* The document listeners are bound once for the life of the page. init() runs
     again on every shopify:section:load in the theme editor, and the header is a
     brand new node each time, so a per-node guard would not stop them stacking. */
  var docBound = false;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function navRoot() {
    return document.querySelector(".tgb-nav");
  }

  function allDetails(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll("header-menu details"));
  }

  function closeAll(root, except) {
    allDetails(root).forEach(function (details) {
      if (details === except) return;
      if (details.open) details.open = false;
    });
  }

  /* A compact dropdown is anchored to its trigger, so near the right edge of the
     viewport it would otherwise be clipped. Measure once the panel is laid out
     and mirror the anchor when it does not fit. */
  function placePanel(details) {
    if (!details.classList.contains("tgb-mm--compact")) return;
    var panel = details.querySelector(".tgb-mm__panel");
    if (!panel) return;
    panel.classList.remove("tgb-mm__panel--flip");
    if (!details.open || !isDesktop()) return;
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - EDGE_GAP) {
      panel.classList.add("tgb-mm__panel--flip");
    }
  }

  function init() {
    var nav = navRoot();
    if (!nav) return;

    if (!nav.__tgbNav) {
      nav.__tgbNav = true;

      allDetails(nav).forEach(function (details) {
        var holder = details.closest("header-menu") || details.parentNode;
        var timer;

        holder.addEventListener("mouseenter", function () {
          if (!isDesktop()) return;
          clearTimeout(timer);
          timer = setTimeout(function () {
            closeAll(nav, details);
            details.open = true;
          }, OPEN_DELAY);
        });

        holder.addEventListener("mouseleave", function () {
          if (!isDesktop()) return;
          clearTimeout(timer);
          timer = setTimeout(function () {
            details.open = false;
          }, CLOSE_DELAY);
        });

        // Keep the panel open when the pointer travels into it.
        var panel = details.querySelector(".tgb-mm__panel");
        if (panel) {
          panel.addEventListener("mouseenter", function () {
            clearTimeout(timer);
          });
        }

        /* One owner for aria-expanded: whatever opens or closes the element —
           hover intent, a click, Dawn's DetailsDisclosure.close() — ends here,
           so the attribute can never drift out of sync with the element. */
        details.addEventListener("toggle", function () {
          var summary = details.querySelector("summary");
          if (summary) {
            summary.setAttribute("aria-expanded", details.open ? "true" : "false");
          }
          if (details.open) closeAll(nav, details);
          placePanel(details);
        });
      });
    }

    if (docBound) return;
    docBound = true;

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" && event.key !== "Esc") return;
      var root = navRoot();
      if (!root) return;
      var open = allDetails(root).filter(function (details) {
        return details.open;
      });
      if (!open.length) return;
      /* Return focus to the trigger before collapsing, otherwise the focused
         link disappears and the keyboard user restarts from the top of the page. */
      var focused = open.filter(function (details) {
        return details.contains(document.activeElement);
      })[0];
      var target = focused || open[0];
      var summary = target.querySelector("summary");
      if (summary && target.contains(document.activeElement)) summary.focus();
      closeAll(root, null);
    });

    document.addEventListener("click", function (event) {
      var root = navRoot();
      if (root && !root.contains(event.target)) closeAll(root, null);
    });

    window.addEventListener(
      "resize",
      function () {
        var root = navRoot();
        if (!root) return;
        allDetails(root).forEach(placePanel);
      },
      { passive: true }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
